import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const fileDeleteMutationAtom = createMutationAtomFactory(
  'files.delete',
  ({ fileId }: { fileId: string }) => ({
    filesDeleteFile: {
      __args: {
        fileID: fileId,
      },
      success: true,
    },
  }),
);
